import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import LoginPage from "./page/LoginPage";
import PhotoUploadPage from "./page/PhotoUploadPage";
import EditTemplatePage from "./page/EditTemplatePage";
import CardsPage from "./page/CardsPage";
import { ToastContainer } from "react-toastify";
import Users from "./page/Users";
import useAuthStore from "./store/useAuthStore";
import { useEffect } from "react";
import GoogleLogin from "./page/GoogleLogin";


const NavBar = () => {
  const location = useLocation();
  const { role } = useAuthStore();

  // Function to check if a route is active
  const isActive = (path) => location.pathname === path;

  return (
    <nav className="w-full bg-black text-white py-4">
      <div className="max-w-6xl mx-auto px-4 flex justify-between items-center">
        <h1 className="text-xl font-bold">Connect</h1>
        <div>
          {role === "admin" && <Link
            to="/users"
            className={`mr-4 hover:underline ${isActive("/users") ? "font-bold underline" : ""
              }`}
          >
            Users
          </Link>}
          <Link
            to="/upload"
            className={`mr-4 hover:underline ${isActive("/upload") ? "font-bold underline" : ""
              }`}
          >
            Upload
          </Link>
          <Link
            to="/edit-template"
            className={`hover:underline ${isActive("/edit-template") ? "font-bold underline" : ""
              }`}
          >
            Template
          </Link>
          <Link
            to="/cards"
            className={`ml-4 hover:underline ${isActive("/cards") ? "font-bold underline" : ""
              }`}
          >
            Cards
          </Link>
        </div>
      </div>
    </nav>
  );
};

const App = () => {
  // const { token, setToken } = useAuthStore();
  const { role, isInternal } = useAuthStore();
  const setIsInternal = useAuthStore((state) => state.setIsInternal)

  const location = useLocation();

  const showNavBar = location.pathname !== "/";

  const isCardsPage = location.pathname === "/cards";


  useEffect(() => {
    if(process.env.REACT_APP_BACKEND_URL==="development"){
      setIsInternal(true)
      return;
    }
    const host = window.location.hostname
    if (host === "connect.cyno.co.in") {
      setIsInternal(true)
    } else if (host === "app.cyno.co.in") {
      setIsInternal(false)
    }
    // else {
    //   setIsInternal(true)
    // }
  }, [setIsInternal])


  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      {showNavBar && <NavBar />}

      <div
        className={
          isCardsPage
            ? "flex-grow overflow-y-auto"
            : "flex-grow flex items-center justify-center"
        }
      >
        <Routes>
          <Route path="/" element={isInternal ? <LoginPage /> : <GoogleLogin />} />
          <Route path="/upload" element={<PhotoUploadPage />} />
          <Route path="/cards" element={<CardsPage />} />
          {role === "admin" && <Route path="/users" element={<Users />} />}
          <Route path="/edit-template" element={<EditTemplatePage />} />
        </Routes>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

const RootApp = () => (
  <Router>
    <App />
  </Router>
);

export default RootApp;
